/**
 * Shared page shell: the green canvas, the single white card, the nav, and a title row.
 * DESIGN_GUIDELINES.md §7.2 — the card always keeps visible green margin at every breakpoint.
 */

import type { ReactNode } from 'react';
import { Group, Stack, Title } from '@mantine/core';
import type { SessionUser } from '../lib/api';
import { AppCanvas } from './AppCanvas';
import { AppNav } from './AppNav';

export function PageShell({
  user,
  onSignOut,
  title,
  actions,
  children,
}: {
  user: SessionUser;
  onSignOut: () => void;
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <AppCanvas>
      <AppNav user={user} onSignOut={onSignOut} />
      <Stack gap="lg" pb={{ base: 64, sm: 0 }}>
        {title ? (
          <Group justify="space-between" align="flex-end" wrap="wrap" gap="sm">
            {typeof title === 'string' ? <Title order={2}>{title}</Title> : title}
            {actions}
          </Group>
        ) : null}
        {children}
      </Stack>
    </AppCanvas>
  );
}
